import KindergartenMenu from "../Component/kindergartenMenu";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from '../Component/Footer'
import LazyLoad from 'react-lazyload';
const KidsStrength = () => {
    return (
        <>
         <KindergartenMenu />
            <Breadcrumb title="Students Strength (Year 2026-2027)" mid="Kindergarten &nbsp; &nbsp;|" tabName="Students Strength (Year 2026-2027)" />
            <div className="innerPage">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div class="table-responsive table-wid">
                                <table className="table">
                                    <thead>
                                        <tr><th>Class </th>
                                            <th>Total Divisions</th>
                                            <th>Total intake</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Nursery </td>
                                            <td>7</td>
                                            <td>239</td>
                                        </tr>
                                        <tr>
                                            <td>LKG</td>
                                            <td>7</td>
                                            <td>279</td>
                                        </tr>
                                        <tr>
                                            <td>HKG </td>
                                            <td>7</td>
                                            <td>275</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default KidsStrength;